import React, { useState, useEffect } from "react";

// components imports
import InputField from "../../common/InputField";
import Button from "../../common/Button";

// Scss imports
import css from "./CreateArchiveItem.module.scss";

// redux
import { useSelector, useDispatch } from "react-redux";

import {
  createArchive,
  manuallyTrigerMessage,
  updateArchive,
} from "../../../redux/actions/archiveActions";

import { getCategories } from "../../../redux/actions/categoriesActions";

interface CreateArchiveItemProps {
  numberOfPapers: number;
  papersFrom?: string;
  papersTo?: string;
  papers?: string[];
  subnumbers: string[];
  baseNumber: string;
  index: number;
  archiveTemplate: any;
  createdAt?: string;
  shelfLifeToT?: number;
  id: string;
  content?: string;
  type?: string;
  shelfLifeToData?: string | number;
  baseNumberId?: string;
  remarkData?: any;
}

const CreateArchiveItem: React.FC<CreateArchiveItemProps> = ({
  numberOfPapers,
  papersFrom,
  papersTo,
  papers,
  subnumbers,
  baseNumber,
  index,
  archiveTemplate,
  createdAt,
  shelfLifeToT,
  id,
  content,
  type,
  shelfLifeToData,
  baseNumberId,
  remarkData,
}) => {
  const dispatch = useDispatch();
  // getting categories from redux state
  const categories = useSelector(
    (state: any) => state.allCategories.categories.data
  );

  // archive data error
  const archiveDataError = useSelector(
    (state: any) => state.archive.archiveDataError
  );

  const [baseNumberCategory, setBaseNumberCategory] = useState("");
  const [form, setForm] = useState({});
  const [message, setMessage] = useState("");

  useEffect(() => {
    dispatch(getCategories());
  }, [dispatch]);

  useEffect(() => {
    const baseNumberCategoryArr = categories.filter((category) => {
      return category._id === baseNumber;
    });

    setBaseNumberCategory(
      baseNumberCategoryArr.length > 0
        ? baseNumberCategoryArr[0].baseNumber
        : ""
    );

    if (type === "createArchive") {
      setForm({
        numberOfPapers: numberQuantity,
        papersFrom: papersFrom,
        papersTo: papersTo,
        papers: papers,
        subnumbers: subnumbers,
        baseNumber: baseNumber,
        content: shortText,
        shelfLifeTo: shelfLifeTo,
        remark: remark,
      });
    } else {
      setForm({
        remark: remark,
        recordNumber: recordNumber,
        recordDate: recordDate,
      });
    }
  }, [categories]);

  // setting up state for the input fields
  const [shortText, setShortText] = useState<string>();
  const [numberQuantity, setNumberQuantity] = useState("");
  const [shelfLifeTo, setShelfLifeTo] = useState<any>(shelfLifeToData);
  const [remark, setRemark] = useState<string>(remarkData);

  // setting up state for the record input fields
  const [recordDate, setRecordDate] = useState<string>("");
  const [recordNumber, setRecordNumber] = useState<string>();

  useEffect(() => {
    dispatch(manuallyTrigerMessage());
  }, []);

  useEffect(() => {
    setForm({
      papersFrom: papersFrom,
      papersTo: papersTo,
      papers: papers,
      subnumbers: subnumbers,
      baseNumber: baseNumberId,
      content: shortText,
      shelfLifeTo: Number(shelfLifeTo),
      remark: remark,
      numberOfPapers: numberQuantity,
    });
  }, [remark, shortText, shelfLifeTo, numberQuantity]);

  useEffect(() => {
    setForm({
      remark: remark,
      recordNumber: recordNumber,
      recordDate: recordDate,
    });
  }, [recordNumber, recordDate]);

  useEffect(() => {
    setMessage(archiveDataError);

    setTimeout(() => {
      dispatch(manuallyTrigerMessage());
    }, 5000);
  }, [archiveDataError]);
  // handling input change
  const handleChange = (e: any, setValue) => {
    setValue(e.target.value);
  };

  // archive documents event
  const archive = () => {
    const filteredData = archiveTemplate.filter((item, indexOne) => {
      return index !== indexOne;
    });

    if (type === "createArchive") {
      dispatch(createArchive(form, filteredData));
      setShortText("");
      //setShelfLifeTo(null);
      setRemark("");
    } else if (type === "destroyArchive") {
      dispatch(updateArchive(form, id));
    }
  };

  return (
    <div className={css.container}>
      <form>
        <InputField
          label="Основни број"
          name="baseNumber"
          id="baseNumber"
          type="text"
          value={
            baseNumberCategory && type === "createArchive"
              ? baseNumberCategory
              : baseNumber
          }
          readOnly={true}
        />
        <InputField
          label="Подбројеви"
          name="subnumbers"
          id="subnumbers"
          type="text"
          value={subnumbers}
          readOnly={true}
        />
        {type === "createArchive" && (
          <>
            <InputField
              label="Документи од"
              name="papersFrom"
              id="papersFrom"
              type="text"
              value={papersFrom ? papersFrom.split("T")[0] : ""}
              readOnly={true}
            />
            <InputField
              label="Документи до"
              name="papersTo"
              id="papersTo"
              type="text"
              value={papersTo ? papersTo.split("T")[0] : ""}
            />
          </>
        )}
        {type === "destroyArchive" && (
          <InputField
            label="Креирана дана"
            name="createdAt"
            id="createdAt"
            type="text"
            value={createdAt ? createdAt.split("T")[0] : ""}
          />
        )}
        <InputField
          label="Количина"
          name="numberOfPapers"
          id="numberOfPapers"
          type="text"
          value={numberQuantity}
          handleChange={(e: any) => handleChange(e, setNumberQuantity)}
        />
        <InputField
          label="Чувати до"
          name="shelfLifeTo"
          id="shelfLifeTo"
          type="text"
          value={type === "createArchive" ? shelfLifeTo : shelfLifeToT}
          handleChange={(e: any) =>
            type === "createArchive" ? handleChange(e, setShelfLifeTo) : ""
          }
          inputType="rowInput"
          readOnly={type === "destroyArchive" ? true : false}
        />
        <InputField
          label="Кратак садржај"
          name="shortText"
          id="shortText"
          type="text"
          value={type === "createArchive" ? shortText : content}
          handleChange={(e: any) =>
            type === "createArchive" ? handleChange(e, setShortText) : ""
          }
          inputType="rowInput"
          readOnly={type === "destroyArchive" ? true : false}
        />
        <InputField
          label="Напомена"
          name="remark"
          id="remark"
          type="text"
          value={remark}
          handleChange={(e: any) => handleChange(e, setRemark)}
          inputType="rowInput"
        />
        {type === "destroyArchive" && (
          <>
            <InputField
              label="Број записника"
              name="recordNumber"
              id="recordNumber"
              type="text"
              value={recordNumber}
              handleChange={(e: any) => handleChange(e, setRecordNumber)}
            />
            <InputField
              label="Датум записника"
              name="recordDate"
              id="recordDate"
              type="date"
              value={recordDate}
              handleChange={(e: any) => handleChange(e, setRecordDate)}
              inputType="rowInput"
            />
          </>
        )}
        <Button
          text={type === "createArchive" ? "Архивирај" : "Уништи"}
          onButtonClickHandler={archive}
          style={{
            borderRadius: "5rem",
            maxHeight: "6rem",
            border: "0.1rem solid gray",
          }}
        />
      </form>

      <p
        className={`${
          message === "Успешно сте архивирали документа" ? css.greenText : ""
        }`}
      >
        {message}
      </p>
    </div>
  );
};

export default CreateArchiveItem;
